<script>
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { actionStore } from "@common/actionStore";
import { SkeletonComponent } from "@syncfusion/ej2-vue-notifications";
import { configStore } from "@common/configStore";
import { ddStore } from "@common/ddStore";
import { GenerateComponent } from "@common/activityStepPanel/GenerateComponent";

const workflowStepStore = {
    // Set some workflow activities here for prevStep/nextStep
};

const runOnceActions = {
    // Put actions in only
};

// Inputs:  vol, aff, activity

const AFF_FIELDS = [
    'AFFILIATION_ID',
    // 'DETAIL_RECORD_ID',
    'AFF_REASON_ID',
    'AFF_REASON',
    'AFF_STATUS_ID',
    'AFF_STATUS',
    // 'AFF_START_DATE',
    // 'AFF_END_DATE',
    'AFF_COMPLIANCE_STATUS',
    'AFF_COMPLIANCE_STATUS_ID',
    // 'AFF_COMPLIANCE_STATUS_VERIFIER',
    // 'AFF_STATUS_VERIFIER_DATE',
    // 'ACTIVITY_ENTITY_TITLE',
    // 'ACTIVITY_ENTITY_ID',
    'AFF_ACTIVITY_ENTITY',
    'AFF_ACTIVITY_ENTITY_ID',
    // 'AFF_ASSIGNMENT_WORKFLOW_STATUS',
    // 'AFF_STATUS_VERIFIER',
    // 'AFF_STATUS_DATETIME',
    // 'AFF_COMPLETE_DATE',
    'AFF_EXPIRATION_DATE',
    'AFF_VOLUNTEER',
    'AFF_VOLUNTEER_ID',
    'AFF_EXPIRING_AFFILIATION_ID',
    'PREV_STEPS',
    'NEXT_STEPS',
    'AFF_RECORDS',
    'AFF_ASSIGNMENT_ID',
    'AFF_RENEWED_AFFILIATION_ID',
    'AFF_IS_INCLUDED',
    'AFF_IS_ENABLED',
    'AFF_IS_COMPLETED',
];
const ACTIVITY_FIELDS = [
    'ACTIVITY_ENTITY_ACTION',
    'ACTIVITY_ENTITY_ID',
    'ACTIVITY_ENTITY_MESSAGE',
    'ACTIVITY_ENTITY_TITLE',
    'ACTIVITY_TYPE_ID',
    'AE_COMPLETED_AFF_STATUS',
    'AE_COMPLETED_AFF_STATUS_ID',
    'AE_COMPLETED_BY_DEFAULT',
    'AE_COMPLETED_LOGIC_FILTER_ID',
    'AE_CSSCLASSES',
    'AE_DEFAULT_AFF_COMPLIANCE_STATUS',
    'AE_DEFAULT_AFF_COMPLIANCE_STATUS_ID',
    'AE_DEFAULT_AFF_STATUS',
    'AE_DEFAULT_AFF_STATUS_ID',
    'AE_DESCRIPTION',
    'AE_ENABLED_AFF_STATUS',
    'AE_ENABLED_AFF_STATUS_ID',
    'AE_ENABLED_BY_DEFAULT',
    'AE_ENABLED_LOGIC_FILTER_ID',
    'AE_ENABLED_SET',
    'AE_ENABLED_SET_AFF_REASON_ID',
    'AE_ENABLED_SET_AFF_START_DATE',
    'AE_COMPLETED_SET_AFF_END_DATE',
    'AE_ENABLED_SET_AFF_STATUS_ID',
    'AE_INCLUDED_AFF_STATUS',
    'AE_INCLUDED_AFF_STATUS_ID',
    'AE_INCLUDED_BY_DEFAULT',
    'AE_INCLUDED_LOGIC_FILTER_ID',
    'AE_VISIBLE_BY_DEFAULT',
    'AE_VISIBLE_AFF_STATUS_ID',
    'AE_VISIBLE_LOGIC_FILTER_ID',
    'AE_IS_COMPLIANCE',
    'AE_ONCE_AND_DONE',
    'AE_ONCE_AND_DONE_INCLUDE_FILTER_ID',
    'AE_TITLE'
];
const SHIFT_FIELDS = [
    'SS_TITLE',
    'SS_DESC',
    'SS_NOTE',
    'SS_DATE',
    'SS_START',
    'SS_FINISH_TIME',
    'SS_END_TIME',
    'SS_START_TIME',
    'SS_PICKUP_INSTR',
    'SA_SSLI_ADDRESS_1',
    'SA_SSLI_ADDRESS_2',
    'SA_SSLI_CITY',
    'SA_SSLI_COUNTRY',
    'SA_SSLI_POSTAL_CODE',
    'SA_SSLI_STATE',
    'SA_SSLI_PHONE',
    'SA_SSLI_CONTACT_PERSON',
    'SA_SSLI_CONTACT_PHONE',
    'ACTIVITY_ENTITY_ID',
    'ASSIGNMENT_ID',
    'AE_AFFILIATION_ID'
];

let compareLogicTimeout = {};
let alreadyComparedLogic = {};
let compareLogicFn = function (cId, workflowId, item, fromTimeout) {
    if (!fromTimeout) {
        if (typeof compareLogicTimeout[cId] === 'undefined') compareLogicTimeout[cId] = false;
        if (compareLogicTimeout[cId]) clearTimeout(compareLogicTimeout[cId]);
        compareLogicTimeout[cId] = setTimeout(() => {
            compareLogicFn(cId, workflowId, item, true);
        }, 5000);
        return;
    }
    let keys = ['include', 'enable', 'complete'];
    for (let j in keys) {
        let key = keys[j];
        let tmpAffID = item?.AFFILIATION_ID;
        if (!tmpAffID) return;
        if (typeof item[key + 'FrontRes'] === 'undefined' || typeof item[key + 'BackendRes'] === 'undefined') return;
        if (alreadyComparedLogic?.[cId]?.[tmpAffID]?.[key]) return;
        if (typeof alreadyComparedLogic?.[cId] === 'undefined') alreadyComparedLogic[cId] = {};
        if (typeof alreadyComparedLogic?.[cId]?.[tmpAffID] === 'undefined') alreadyComparedLogic[cId][tmpAffID] = {};
        if (typeof alreadyComparedLogic?.[cId]?.[tmpAffID]?.[key] === 'undefined') alreadyComparedLogic[cId][tmpAffID][key] = true;
        if (!!item[key + 'FrontRes'] !== !!item[key + 'BackendRes']) {
            let tmpErrorMmessage = "\n";
            tmpErrorMmessage += key + " backend logic result: " + (item[key + 'BackendRes'] ? 'true' : 'false') + "\n";
            tmpErrorMmessage += key + " frontend logic result: " + (item[key + 'FrontRes'] ? 'true' : 'false') + "\n";
            tmpErrorMmessage += "Volunteer ID: " + item.record.VOLUNTEER_ID + "\n";
            tmpErrorMmessage += "Affiliation ID: " + tmpAffID + "\n";
            tmpErrorMmessage += "Workflow ID: " + workflowId + "\n";
            tmpErrorMmessage += "Activity Entity ID: " + item.ACTIVITY_ENTITY_ID + "\n";
            errorHandler.handle(tmpErrorMmessage, { messageSubject: "Backend logic not equal with frontend" });
        }
    }
};

const locals = {
    formatToUI(step, relatedRecords) {
        // Mapping/Formatting Functions
        let setLogicRecords = (serverLogic, step) => {
            let output = [];
            let stepRecords = step.relatedRecords;
            if (!library.isJson(serverLogic)) return output;
            let logicObj = JSON.parse(serverLogic);
            let logicRule = logicObj['[FilterEditor::FiltersColumns]'];
            if (Array.isArray(logicRule)) {
                for (let i in logicRule) {
                    if (i === 'length') continue;
                    if (typeof logicRule[i].GRID_FIELD_NAME !== 'string') continue;
                    output[i] = { criteriaRecord: 'dynamically' };
                    // Set the perspective
                    let logicPsp = logicRule[i].FLT_SELECT_FIELD_PERSPECTIVE_ABBREV;
                    if (logicPsp === 'lbe') {
                        if (logicRule[i].LBE_TYPE === 5) logicPsp = 'waiver'; // NOSONAR
                        if (logicRule[i].LBE_TYPE === 6) logicPsp = 'training'; // NOSONAR
                    }
                    let assignmentSubRecord = logicRule[i].FLT_CLAUSE_PSP_OPTION; // Sub-record is related orgs (eg: tier 500) ie: orgKind
                    // Check for is assignment record
                    if (logicRule[i].GRID_FIELD_NAME === 'AFF_ASSIGNMENT_STATUS') {
                        output[i].recordId = stepRecords.ASSIGNMENT_ID;
                    }
                    // Check for a selected "Sub Record" from the assignment
                    else if (assignmentSubRecord && assignmentSubRecord !== 2) {
                        if (assignmentSubRecord === 1) output[i].recordId = stepRecords.ASSIGNMENT_ID;
                        else if (assignmentSubRecord === 9999) output[i].recordId = stepRecords.DETAIL_RECORD_ID; // NOSONAR
                        else if (logicPsp === 'aff') output[i].recordId = stepRecords?.ASSIGNMENT?.LINKED_AFFILIATIONS?.[assignmentSubRecord];
                        else output[i].recordId = stepRecords?.ASSIGNMENT?.LINKED_RECORDS?.[assignmentSubRecord];
                    }
                    // Otherwise link using the perspective
                    else if (logicPsp === 'vol') output[i].recordId = stepRecords?.VOLUNTEER_ID;
                    else if (logicPsp === 'aff') output[i].recordId = stepRecords?.aff?.AFFILIATION_ID;
                    else if (logicPsp === 'lbe') output[i].recordId = stepRecords?.lbe?.LOG_BOOK_ENTRY_ID;
                    else if (logicPsp === 'waiver') output[i].recordId = stepRecords?.waiver?.LOG_BOOK_ENTRY_ID;
                    else if (logicPsp === 'training') output[i].recordId = stepRecords?.training?.LOG_BOOK_ENTRY_ID;
                    else if (logicPsp === 'sch') {
                        // output[i].recordId = records.shift && records.shift.SCHEDULE_SLOT_ID;
                        output[i].criteriaRecord = 'object2';
                    }
                    else if (logicPsp === 'client') {
                        output[i].criteriaRecord = 'component.ecUserProperty';
                    }
                }
            }
            return output;
        };
        let mapTemplates = (tItem, step, hideWhenComplete, hideWhenDisabled) => {
            tItem.template = tItem.TEXT;
            tItem.include = tItem.IS_DEFAULT !== 0 || !tItem.LOGIC;
            if (tItem.LOGIC) {
                let logicRecords = setLogicRecords(tItem.LOGIC, step);
                let criteria = library.parseLogicToFront(tItem.LOGIC, logicRecords);
                tItem.includeWhen = [{ criteria, resultType: 'returnCriteria' }];
            }
            tItem.hideWhenDisabled = hideWhenDisabled;
            tItem.hideWhenComplete = hideWhenComplete;
            return tItem;
        };
        let parseActionLogic = (action, step, logicType) => {
            if (action[logicType]) {
                let logicRecords = setLogicRecords(action[logicType], step);
                let criteria = library.parseLogicToFront(action[logicType], logicRecords);
                return [{ criteria, resultType: 'returnCriteria' }];
            }
            return false;
        };
        let mapActions = (action, step, hideWhenComplete, hideWhenDisabled) => {
            let tAction = library.cloneObj(action);
            tAction.label = tAction.TEXT;
            let tmpText = tAction.TEXT ? tAction.TEXT : '';
            let tmpId = tAction.ACTIVITY_ENTITY_ACTION_ID ? tAction.ACTIVITY_ENTITY_ACTION_ID : '';
            tAction.title = `${tmpText} (Action ID: ${tmpId})`;
            // Convert legacy config to standard
            // TODO: Remove this code after all configurations have been updated https://samaritan.atlassian.net/browse/DEVD-1202
            if (tAction.ACTION
                && typeof tAction.ACTION === 'object'
                && !Array.isArray(tAction.ACTION)
                && tAction.ACTION.params
            ) {
                let chainedActions = [];
                if (tAction.ACTION.params.actionChaining) {
                    chainedActions = library.cloneObj(tAction.ACTION.params.actionChaining);
                    delete tAction.ACTION.params.actionChaining;
                }
                let formattedVal = [tAction.ACTION];
                formattedVal = formattedVal.concat(chainedActions);
                tAction.action = formattedVal;
            } else tAction.action = tAction.ACTION;
            tAction.actionIcon = tAction.ACTION_ICON;
            tAction.include = !!tAction.IS_DEFAULT;
            if (tAction.CSS_CLASSES) tAction.cssClasses = tAction.CSS_CLASSES;

            tAction.includeWhen = parseActionLogic(tAction, step, 'LOGIC');
            tAction.disableWhen = parseActionLogic(tAction, step, 'DISABLE_LOGIC');

            tAction.hideWhenDisabled = hideWhenDisabled;
            tAction.hideWhenComplete = hideWhenComplete;
            return tAction;
        };
        // TODO maybe we don't need processStepLogic, and instead use AFF_IS_INCLUDED
        let processStepLogic = (step) => {
            let v1 = 1; // By Default
            let v2 = 2; // Use Logic Editor
            let v3 = 3; // Use Volunteer's Affiliation Status
            // Set include property
            let setStepState = (stepKey) => {
                // stepKey is one of: include, enable, complete
                // let partialKey = 'AE_' + stepKey.toUpperCase() + 'D'; // eg: AE_INCLUDED, AE_ENABLED, AE_COMPLETED
                let partialKey = 'AE_' + stepKey.toUpperCase() + (stepKey !== 'visible' ? 'D' : ''); // eg: AE_INCLUDED, AE_ENABLED, AE_COMPLETED, AE_VISIBLE
                let sOption = step[partialKey + '_BY_DEFAULT']; // eg: 1, 2, 3
                let affStatusKey = partialKey + '_AFF_STATUS_ID'; // eg: AE_INCLUDED_AFF_STATUS_ID
                let logicKey = partialKey + '_LOGIC_FILTER_ID'; // eg: AE_INCLUDED_LOGIC_FILTER_ID
                let criteria;
                if (!sOption || sOption === v1) {
                    criteria = {
                        rules: [{
                            field: partialKey + '_BY_DEFAULT',
                            operator: 'equal',
                            type: 'numeric',
                            value: v1,
                            criteriaRecord: 'object1' // previous step completed
                        }],
                        condition: 'and'
                    };
                } else if (sOption === v2 && step[logicKey]) {
                    let logicRecords = setLogicRecords(step[logicKey], step);
                    criteria = library.parseLogicToFront(step[logicKey], logicRecords);
                } else if (sOption === v3) {
                    let stepRecords = step.relatedRecords;
                    // Map selected status option from activity profile to logic criteria
                    if (stepRecords.aff) {
                        criteria = {
                            rules: [{
                                label: 'AFF:Status',
                                field: 'AFF_STATUS_ID',
                                operator: 'equal',
                                type: 'numeric',
                                value: step[affStatusKey],
                                psp: 'aff',
                                criteriaRecord: 'dynamically',
                                recordId: stepRecords.aff.AFFILIATION_ID
                            }],
                            condition: 'and'
                        };
                    }
                }
                // includeWhen
                // enableWhen
                // completeWhen
                if (criteria) step[stepKey + 'When'] = [{ criteria, resultType: 'returnCriteria' }];
            };
            setStepState('include');
            setStepState('visible');
            setStepState('enable');
            setStepState('complete');
            let setOnChangeActions = () => {
                if (!step.AE_ENABLED_SET) return;
                const stepRecords = step.relatedRecords;
                const currStatus = stepRecords?.aff?.AFF_STATUS_ID;
                const newStatus = parseInt(step.AE_ENABLED_SET_AFF_STATUS_ID, 10) > 0 && step.AE_ENABLED_SET_AFF_STATUS_ID;
                const newReason = parseInt(step.AE_ENABLED_SET_AFF_REASON_ID, 10) > 0 && step.AE_ENABLED_SET_AFF_REASON_ID;
                const defaultStatus = parseInt(step.AE_DEFAULT_AFF_STATUS_ID, 10) > 0 && step.AE_DEFAULT_AFF_STATUS_ID;
                const newDate = typeof step.AE_ENABLED_SET_AFF_START_DATE === 'string' && step.AE_ENABLED_SET_AFF_START_DATE ? step.AE_ENABLED_SET_AFF_START_DATE : false;
                // TODO: not being used, delete?
                // const newEndDate = typeof step.AE_COMPLETED_SET_AFF_END_DATE === 'string' && step.AE_COMPLETED_SET_AFF_END_DATE ? step.AE_COMPLETED_SET_AFF_END_DATE : false;

                if (!newStatus || currStatus !== defaultStatus) return;

                let changeField;
                let criteriaObj;
                // TODO pickup here and start working
                switch (+step.AE_ENABLED_SET) {
                    case 1: // Previous step is complete
                        changeField = 'complete';
                        criteriaObj = 'object3';
                        break;
                    case 2: // All previous steps are complete
                        changeField = 'previousStepsComplete';
                        criteriaObj = 'object1';
                        break;
                    // additional cases are coming soon. FT-531
                    default:
                        changeField = false;
                        criteriaObj = false;
                }
                // Map selected status option from activity profile to logic criteria
                const onChangeCriteria = {
                    rules: [{ // This rule is intentionally duplicating the logic in line above "stepRecords.aff.AFF_STATUS_ID..."
                        label: 'AFF:Status ID',
                        field: 'AFF_STATUS_ID',
                        operator: 'equal',
                        type: 'numeric',
                        value: defaultStatus,
                        psp: 'aff',
                        criteriaRecord: 'dynamically',
                        recordId: stepRecords?.aff?.AFFILIATION_ID
                    }, {
                        field: changeField,
                        operator: 'equal',
                        type: 'boolean',
                        value: true,
                        criteriaRecord: criteriaObj // previous step completed
                    }],
                    condition: 'and'
                };
                // Put the complete onChangeActions configuration into the step configuration
                const onChangeActions = [
                    {
                        logic: [{
                            criteria: onChangeCriteria,
                            resultType: 'returnCriteria',
                        }],
                        actions: [
                            {
                                action: 'updateAffiliation',
                                params: {
                                    affID: stepRecords?.aff?.AFFILIATION_ID,
                                    AFF_STATUS: newStatus,
                                    AFF_REASON: newReason, // It might be false
                                    AFF_START_DATE: newDate,
                                    disableResponseMessage: true,
                                    isSystemAutomatedAction: true
                                }
                            }
                        ],
                        executeIfLogicResult: true,
                        runOnce: true
                    }
                ];
                step.onChangeActions = onChangeActions;
            };
            setOnChangeActions();
        };

        step.aeId = step.ACTIVITY_ENTITY_ID;
        step.volId = step.VOLUNTEER_ID;
        step.relatedRecords = relatedRecords;
        step.stepRecords = relatedRecords;
        step.record = relatedRecords.aff;
        step.ASSIGNMENT_ID = relatedRecords.ASSIGNMENT_ID;

        // set server provided default include/enable/complete
        if (step.record) {
            step.include = step.record.AFF_IS_INCLUDED === 'Yes';
            step.includeBackendRes = step.record.AFF_IS_INCLUDED === 'Yes';
            step.enable = step.record.AFF_IS_ENABLED === 'Yes';
            step.enableBackendRes = step.record.AFF_IS_ENABLED === 'Yes';
            step.complete = step.record.AFF_IS_COMPLETED === 'Yes';
            step.completeBackendRes = step.record.AFF_IS_COMPLETED === 'Yes';
            step.record.ASSIGNMENT_ID = relatedRecords.ASSIGNMENT_ID;
            step.record.ASSIGNMENT = relatedRecords.ASSIGNMENT;
        }
        // convert ID
        if (!library.objIsEmpty(step.relatedRecords)) {
            for (let psp in step.relatedRecords) {
                if (typeof step.relatedRecords[psp]?.ID !== 'undefined') step[psp + 'Id'] = step.relatedRecords[psp].ID;
            }
        }

        // CSS classes
        if (typeof step.AE_CSSCLASSES !== 'undefined') step.cssClasses = step.AE_CSSCLASSES;

        if (step.AE_IS_COMPLIANCE) {
            const complianceClass = 'compliance-status-' + step?.relatedRecords?.aff?.AFF_COMPLIANCE_STATUS_ID;
            step.cssClasses = step.cssClasses === 'undefined' ? complianceClass : step.cssClasses + ' ' + complianceClass;
        }

        // Map TITLE, DESCRIPTION, ACTIONS
        step.isVisible = !this.userStore?.coordinator?.availableActivities
            || !!this.userStore.coordinator.availableActivities.find((ca) => step.ACTIVITY_ENTITY_ID === ca.ACTIVITY_ENTITY_ID);
        if (step.isVisible) {
            if (Array.isArray(step.ACTIVITY_ENTITY_TITLE)) {
                if (!step.ACTIVITY_ENTITY_TITLE.length) step.titles = [{ TEXT: step.AE_TITLE, template: `<div>${step.AE_TITLE}</div>` }];
                else step.titles = step.ACTIVITY_ENTITY_TITLE.map((title) => mapTemplates(title, step));
            }
            // NOTE: Sometimes there are no messages
            if (Array.isArray(step.ACTIVITY_ENTITY_MESSAGE)) step.descriptions = step.ACTIVITY_ENTITY_MESSAGE.map((description) => mapTemplates(description, step, !description.SHOW_WHEN_COMPLETE, true));
            if (Array.isArray(step.ACTIVITY_ENTITY_ACTION)) step.actions = step.ACTIVITY_ENTITY_ACTION.map((action) => mapActions(action, step, !action.SHOW_WHEN_COMPLETE, true));
        }
        else {
            step.titles = [{
                template: "<div>" + ddStore.getAliasSync('WORKFLOW', 'WORKFLOW_STEP_UNAVAILABLE_WARNING') + "</div>",
                include: true
            }];
            step.descriptions = [{
                template: "<div>" + ddStore.getAliasSync('WORKFLOW', 'WORKFLOW_STEP_NOT_VISIBLE_WARNING') + "</div>",
                include: true
            }];
            step.actions = [];
            step.cssClasses += ' step-not-visible';
            step.excludeFromCount = true;
        }

        // Step Logic
        processStepLogic(step);

        return step;
    },
    addFormattedMessages(step) {
        // Add coordinator actions and messages to step descriptions
        let adminControls = {
            template: `<div>
                <button type="button" class="coordinator-action-button" title="Edit Affiliation"
                    @click="actionStore.editAffiliation({ affID: record.AFFILIATION_ID, showInDialog: { AFF_STATUS: true, AFF_REASON: true, AFF_NOTE: true, AFF_START_DATE_TYPE: true, AFF_START_DATE: true, AFF_EXPIRATION_DATE_TYPE: true, AFF_EXPIRATION_DATE: true } })"
                ><span class="h-button-text">Edit</span></button>
            </div>`,
            cssClasses: 'coordinator-actions',
            includeWhen: [{
                criteria: {
                    rules: [{
                        field: 'CLIENT_IS_ADMIN',
                        type: 'string',
                        operator: 'equal',
                        value: 'yes',
                        criteriaRecord: 'component.ecUserProperty'
                    }],
                    condition: 'and'
                },
                resultType: 'returnCriteria'
            }]
        };
        let coordinatorControls = {
            template: `<div>
                <button type="button" class="coordinator-action-button" title="View History"
                    @click="actionStore.openComponentDialog(
                        {
                            componentId: 'itemList_affiliation_history__workflow_step_' + index,
                            contextRecordIds: { affId: record.AFFILIATION_ID },
                            dialogSettings: {title: 'Affiliation History'},
                            component: {
                                volId: component.volId,
                                oppId: component.oppId,
                                orgId: component.orgId,
                                lbeId: component.lbeId,
                                schId: component.schId,
                                affId: component.affId,
                                aeId: component.aeId
                            }
                        }
                    )"
                ><span class="h-button-text">View History</span></button>
            </div>`,
            cssClasses: 'coordinator-actions',
            includeWhen: [{
                criteria: {
                    rules: [{
                        field: 'CLIENT_ROLE_OPTION',
                        type: 'string',
                        operator: 'isnotempty',
                        criteriaRecord: 'component.ecUserProperty'
                    }],
                    condition: 'and'
                },
                resultType: 'returnCriteria'
            }]
        };
        let coordinatorMessages = {
            template: `<div>
                <div class="aff-info-text">{{record.affStatusText}}</div>
                <div class="aff-info-text">{{record.affReasonText}}</div>
                <div class="aff-info-text">(ID: {{record.AFFILIATION_ID}})</div>
            </div>`,
            cssClasses: 'info-messages coordinator-messages',
            includeWhen: [{
                criteria: {
                    rules: [{
                        field: 'CLIENT_ROLE_OPTION',
                        type: 'string',
                        operator: 'isnotempty',
                        criteriaRecord: 'component.ecUserProperty'
                    }],
                    condition: 'and'
                },
                resultType: 'returnCriteria'
            }]
        };
        let volunteerMessages = {
            template: `<div>
                <div class="aff-info-text">(ID: {{record.AFFILIATION_ID}})</div>
            </div>`,
            cssClasses: 'info-messages volunteer-messages',
            includeWhen: [{
                criteria: {
                    rules: [{
                        field: 'CLIENT_ROLE_OPTION',
                        type: 'string',
                        operator: 'isempty',
                        criteriaRecord: 'component.ecUserProperty'
                    }],
                    condition: 'and'
                },
                resultType: 'returnCriteria'
            }]
        };
        let refreshStep = {
            template: `<div>
                <button type="button" class="coordinator-action-button" title="Refresh Step"
                    @click="actionStore.refreshWorkflowStep({ record }); toggleDelay(3600, 'refreshing')"
                >
                    <span v-show="!templateData.refreshing" class="h-button-text">Refresh</span>
                    <span v-show="templateData.refreshing">Refreshing</span>
                </button>
                <i v-show="templateData.refreshing"  class="fa-duotone fa-solid fa-ellipsis fa-bounce fa-xl" style="--fa-primary-color: #ed135e; --fa-secondary-color: #EF7D22; --fa-secondary-opacity: 1;"></i>
            </div>`,
            cssClasses: 'coordinator-actions',
            // includeWhen: [{
            //     criteria: {
            //         rules: [{
            //             field: 'CLIENT_ROLE_OPTION',
            //             type: 'string',
            //             operator: 'isnotempty',
            //             criteriaRecord: 'component.ecUserProperty'
            //         }],
            //         condition: 'and'
            //     },
            //     resultType: 'returnCriteria'
            // }]
        };
        let expirationMessage = {
            template: `<div v-if="record.AFF_EXPIRATION_DATE && record.AFF_COMPLIANCE_STATUS_ID !== 3">
                <span class="expiration-flag"
                    v-if="moment().isSameOrAfter(moment(record.AFF_EXPIRATION_DATE, 'MM/DD/YYYY').subtract(30, 'days'))
                    && moment().isBefore(moment(record.AFF_EXPIRATION_DATE, 'MM/DD/YYYY'))">
                    Status: <span class="expiring">Expiring soon {{record.AFF_EXPIRATION_DATE}}
                    <span v-if="record.AFF_COMPLIANCE_STATUS_ID === 5"> (Renewal Started)</span>
                    </span>
                </span>
                <span class="expiration-flag"
                      v-else-if="moment().isSameOrAfter(moment(record.AFF_EXPIRATION_DATE, 'MM/DD/YYYY'))"
                      >Status: <span class="expired">Expired {{record.AFF_EXPIRATION_DATE}}</span></span>
                <span class="expiration-flag" v-else>
                    <span class="current">Current expires: {{record.AFF_EXPIRATION_DATE}}</span></span>
            </div>`,
            cssClasses: 'expiration-status'
        };
        let renewalInProgress = {
            template: `<div v-if="record.renewalExpDate && record.AFF_STATUS_ID === 3">
                            <p>Renewal {{record.affStatusText}} - Expires: {{record.renewalExpDate}}</p>
                       </div>`,
            cssClasses: 'renewal-in-progress-msg'
        };
        const expirationTemplate = {
            template: `<div class="activity-expiration expiration-flag" v-if="record.AFF_COMPLIANCE_STATUS_ID === 3 && !record.renewalExpDate && record.AFF_STATUS_ID !== 3">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                <div class="expiration-text">
                                    <strong style="display: flex">
                                        Expiring Soon
                                        <span v-if="record.AFF_EXPIRATION_DATE"
                                              style="font-weight: normal; color: #4c4c4c; margin-left: 6px"
                                        >- {{record.AFF_EXPIRATION_DATE}}</span>
                                    </strong>
                                    <span>
                                        This task is about to expire, click the button to begin renewal.
                                    </span>
                                </div>
                                <button type="button"
                                        class="coordinator-action-button"
                                        title="Renew"
                                        @click="actionStore.renewActivity(
                                                    {
                                                        currentAffId: record.AFFILIATION_ID,
                                                        volId: record.AFF_VOLUNTEER_ID,
                                                        activityId: record.ACTIVITY_ENTITY_ID,
                                                        repeatOrgId: '',
                                                        fields: [
                                                            { field: 'AFF_STATUS', value: 3},
                                                            { field: 'AFF_REASON', value: 503},
                                                            { field: 'AFF_COMPLIANCE_STATUS', value: 5},
                                                        ]
                                                    })"
                                ><span>Renew</span>
                                </button>
                           </div>`,
            cssClasses: 'renew-message'
        };
        if (!Array.isArray(step.descriptions)) step.descriptions = [];
        step.descriptions.push(...[expirationTemplate, expirationMessage, renewalInProgress, coordinatorMessages, volunteerMessages, coordinatorControls, adminControls, refreshStep]);
        // TODO: Add other merge rules
        return step;
    },
};

const editorSettings = {
    affiliationIdSource: {
        type: 'dropdown',
        label: 'Affiliation ID Source',
        items: [
            { text: 'From HTML Attribute "attribute-aff-id"', value: 'props' },
            { text: 'Context Affiliation', value: 'context' },
            { text: 'Find Match Using Volunteer/Activity', value: 'match' },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    relatedActivitySource: {
        type: 'dropdown',
        label: 'Matching Activity Source',
        items: [
            { text: 'From HTML Attribute "attribute-ae-id"', value: 'props' },
            { text: 'Context Activity', value: 'context' },
            { text: 'Specific Activity', value: 'specific' },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    relatedActivityId: {
        type: 'dropdown',
        label: 'Specific Related Activity',
        itemsSource: '',
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    relatedVolSource: {
        type: 'dropdown',
        label: 'Matching Volunteer Source',
        items: [
            { text: 'from HTML Attribute "attribute-vol-id"', value: 'props' },
            { text: 'Context Volunteer', value: 'context' },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    itemIconType: {
        id: 'itemIconType',
        type: 'dropdown',
        items: [
            { text: 'None', value: 'none' },
            { text: 'Number', value: 'number' },
            { text: 'Avatar Image', value: 'avatar' },
            { text: 'First Name Initial', value: 'first_initial' },
            { text: 'Last Name Initial', value: 'last_initial' },
        ],
        fields: { text: 'text', value: 'value' },
        label: 'Main Icon for Item',
        helpText: 'Specify the icon for each item.',
        default: 'number'
    },
    itemIconSize: {
        id: 'itemIconSize',
        type: 'dropdown',
        items: [
            { text: 'Small', value: 'small' },
            { text: 'Medium', value: 'medium' },
            { text: 'Large', value: 'large' },
        ],
        fields: { text: 'text', value: 'value' },
        helpText: 'Specify the size of the item icon.',
        label: 'Item Icon Size',
        default: 'small',
        logic: [
            {
                record: 'self',
                prop: 'display',
                valueType: 'criteria',
                criteria: "this.controls.itemIconType.value === 'number' || this.controls.itemIconType.value === 'avatar' || this.controls.itemIconType.value === 'first_initial' || this.controls.itemIconType.value === 'last_initial'"
            }
        ],
    },
    avatarContactCardId: {
        type: 'dropdown',
        id: 'avatarContactCardId',
        itemsSource: 'componentStore.getList(true)',
        itemsFilter: 'this.item.cType === "contactCard"',
        fields: { text: 'cId', value: 'cId' },
        label: 'Avatar Contact Card ID',
        helpText: 'Choose the Contact Card to use for the Avatar Icon.',
        logic: [
            {
                record: 'self',
                criteriaRecord: 'component',
                prop: 'display',
                valueType: 'criteria',
                criteria: "this.controls.itemIconType.value === 'avatar'"
            }
        ]
    },
};

const activityStepPanelConfig = {
    cId: "activityStepPanel",
    cType: "activityStepPanel",
    cTitle: "Activity Step Panel",
    cTemplate: `<div v-if="logicParserReady && !ddLoading && mappedStep.visible" class="activity-step-panel" :class="mappedStep.cssClasses">
        <div class="item-icon" v-if="stepNumber">
            <span>{{stepNumber}}</span>
        </div>
        <div class="item-content">
            <div v-for="(title, iindex) in mappedStep.activeTitles" :class="title.cssClasses" :key="iindex">
                <component :is="title.templateComponent.cId" :key="title.templateComponent.cId" :record="mappedStep.record" class="item-title"></component>
            </div>
            <div v-for="(description, iindex) in mappedStep.activeDescriptions" :class="description.cssClasses" :key="iindex">
                <component :is="description.templateComponent.cId" :key="description.templateComponent.cId" :record="mappedStep.record"></component>
            </div>
        </div>
        <div class="item-action-area action-ctrls" :class="mappedStep.actionButtonDisplay">
            <div v-for="(action, iindex) in mappedStep.activeActions"
                 class="item-action-item e-icons"
                 :class="mappedStep.actionIcon"
                 :key="action.actionId"
            >
                <control :name="action.actionId"
                         :key="action.actionId"
                         :ref="action.ref || action.id"
                         :actionParams="[action, mappedStep]"
                         data-test-id="action.dataTestId"
                         :class="action.cssClasses"
                         :disabled="action.disabled"
                         :label="action.label"
                         :style="{color:action.actionTextColor, background:action.actionBackgroundColor, borderRadius:mappedStep.actionBorderRadius}"
                         :prop-config="{
                                removeOnDestroy: true,
                                hideLabel: action.hideLabel,
                                type: 'button',
                                actionIcon: action.ACTION_ICON || action.actionIcon,
                                onclick: actionClick
                         }"
                ></control>
                <p v-if="action.message">{{action.message}}</p>
            </div>
        </div>
        <div class="item-action-area complete-indicator" v-if="mappedStep.complete">
            <span class="e-icons e-complete"></span>
            <span style="font-size:20px; font-weight: bold;">Complete</span>
        </div>
    </div>`,
    controls: []
};

const activityStepPanelCmp = {
    name: "activityStepPanel",
    editorSettings: editorSettings,
    props: {
        index: {
            excludeFromStore: true
        },
        record: { // Returns contextual information, such as tab info, assignment, workflow ID from User's Current View
            excludeFromStore: true
        },
        editorVisible: {
            type: Boolean,
            default: false
        },
        prevStep: { // comes from itemList
            excludeFromStore: true,
            default: false
        },
        nextStep: { // comes from itemList
            excludeFromStore: true,
            default: false
        },
    },
    data() {
        return {
            logicParserReady: false,
            viewSourceRecordData: false,
            affSubscription: false,
            activitySubscription: false,
            shiftSubscription: false,
            statusOptions: [],
            reasonOptions: [],
            prevAffId: false,
        };
    },
    computed: {
        stepNumber() {
            return this.index !== undefined && this.index !== null
                ? this.index + 1
                : false;
        },
        affRecord() {
            let affId = this.affId; // comes from context record
            if (!affId) return {};
            // TODO Do we need to subscribe, or will the auto subscribe do the task?
            if (!this.affSubscription) {
                let payload = {
                    source: 'sds_getProfileField',
                    params: {
                        recordPsp: 'aff',
                        recordId: affId,
                        fields: AFF_FIELDS,
                        // TODO @Dima we need to figure out something new with strictTypeResults
                        // params: { strictTypeResults: true }
                    },
                    updateFrequency: 20,
                };
                this.affSubscription = this.recordStore.subscribe(payload, this.cId, false, false);
            }
            let affRecord = library.cloneObj(this.recordStore.records.aff[affId]);
            // Check for all necessary fields
            if (!affRecord.AFF_STATUS_ID || !affRecord.AFF_RECORDS) return affRecord; // TODO expand this to check for all necessary fields
            // TODO do we really need this?
            let formatActivityAffiliation = (iAffRecord) => {
                if (!iAffRecord.ACTIVITY_ENTITY_ID && iAffRecord.AFF_RECORDS?.[8]) {
                    iAffRecord.ACTIVITY_ENTITY_ID = Number(iAffRecord.AFF_RECORDS[8][0]);
                }
                let volId = iAffRecord.AFF_VOLUNTEER_ID;
                iAffRecord.VOLUNTEER_ID = volId;
                iAffRecord.volId = volId;
                if (!iAffRecord.HISTORY) iAffRecord.HISTORY = {};
                iAffRecord.HISTORY = Object.values(iAffRecord.HISTORY).reverse();
                // eslint-disable-next-line no-loop-func
                let statusOption = this.statusOptions.find((status) => status.value === iAffRecord.AFF_STATUS_ID);
                if (typeof statusOption?.text !== 'undefined') iAffRecord.affStatusText = statusOption.text;
                // eslint-disable-next-line no-loop-func
                let reasonOption = this.reasonOptions.find((status) => status.value === iAffRecord.AFF_REASON_ID);
                if (typeof reasonOption?.text !== 'undefined') iAffRecord.affReasonText = reasonOption.text;
                if (iAffRecord.AFF_EXPIRING_AFFILIATION_ID) iAffRecord.renewalExpDate = this.recordStore.records.aff?.[+iAffRecord.AFF_EXPIRING_AFFILIATION_ID]?.AFF_EXPIRATION_DATE;
                return iAffRecord;
            };
            // const findRenewalAff = (affId) => {
            //     // Recurse until we have no new complianceRenewalAffId property on the record
            //     let newAffId = subscriptionRecords[affId]?.complianceRenewalAffId || affId;
            //     if (subscriptionRecords[newAffId]?.complianceRenewalAffId) {
            //         return findRenewalAff(subscriptionRecords[newAffId].complianceRenewalAffId);
            //     }
            //     // Add compliance expiration date to renewal record
            //     if (subscriptionRecords[affId]?.complianceRenewalAffId) {
            //         subscriptionRecords[newAffId].renewalExpDate = subscriptionRecords[affId]?.AFF_EXPIRATION_DATE;
            //     }
            //     return newAffId;
            // };
            affRecord = formatActivityAffiliation(affRecord);
            let currAffId = affRecord.AFF_RENEWED_AFFILIATION_ID || affRecord.complianceRenewalAffId || affId;
            if (currAffId !== this.affId) {
                // TODO Fix this make it work without having to get all subscription records
                affRecord.renewalExpDate = affRecord.AFF_EXPIRATION_DATE;
                affRecord.affId = currAffId;
            }
            return affRecord;
        },
        activityId() {
            return this.aeId || this.affRecord?.ACTIVITY_ENTITY_ID;
        },

        // TODO move this out of computed
        activityRecord() {
            // TODO make formatted step be part of the future workflowStore
            let activityId = this.activityId;
            if (!activityId || (!this.editorVisible && !this.affId)) return {};
            // Create the subscription if it doesn't exist.
            // Note: We aren't using getSubscription to access the record
            if (!this.activitySubscription) {
                let payload = {
                    source: 'sds_getProfileField',
                    params: {
                        recordPsp: 'ae',
                        recordId: activityId,
                        fields: ACTIVITY_FIELDS,
                        params: { strictTypeResults: true }
                    },
                    updateFrequency: 0,
                };
                this.activitySubscription = this.recordStore.subscribe(payload, this.cId, false, false);
            }
            // Use the actual record from the store for our computed
            let activityRecord = library.cloneObj(this.recordStore.records.ae[activityId]);
            // Check for all necessary fields before formatting
            // Format the activity to a Workflow Step Panel
            activityRecord.AFFILIATION_ID = this.affId;
            activityRecord = locals.formatToUI(activityRecord, this.relatedRecords); // Note:  takes 3ms to process
            activityRecord = locals.addFormattedMessages(activityRecord, this);
            // Process the workflowViewer -> itemList record changes
            if (!Array.isArray(activityRecord.titles)) activityRecord.titles = [];
            activityRecord.titles.forEach((cTitle, titleIndex) => {
                cTitle.templateComponent = new GenerateComponent(this, cTitle.template, 'title', titleIndex);
            });
            if (!Array.isArray(activityRecord.descriptions)) activityRecord.descriptions = [];
            activityRecord.descriptions.forEach((cDescription, descIndex) => {
                cDescription.templateComponent = new GenerateComponent(this, cDescription.template, 'description', descIndex);
            });
            // TODO find a better way to determine if the step data is loaded
            let affIsReady = this.editorVisible || (this.affRecord.AFF_STATUS_ID && this.affRecord.AFF_RECORDS);
            if (
                activityRecord.ACTIVITY_ENTITY_ID
                && activityRecord.ACTIVITY_ENTITY_TITLE
                && activityRecord.ACTIVITY_ENTITY_MESSAGE
                && activityRecord.ACTIVITY_ENTITY_ACTION
                && activityRecord.AE_INCLUDED_BY_DEFAULT
                && activityRecord.AE_ENABLED_BY_DEFAULT
                && activityRecord.AE_COMPLETED_BY_DEFAULT
                && affIsReady
            ) activityRecord.loaded = true;
            return activityRecord;
        },
        referenceId() {
            return this.record?.assignmentId + '_' + this.record.workflowId;
        },
        relatedRecords() {
            if (!this.affRecord?.AFF_RECORDS) return {};
            let prevAffId = this.prevAffId || this.prevStep?.AFFILIATION_ID || this.affRecord?.PREV_STEPS?.[0];
            let nextAffId = this.nextStep?.AFFILIATION_ID || this.affRecord?.NEXT_STEPS?.[0];
            let volId = this.affRecord?.AFF_RECORDS?.[1]?.[0];
            let lbeId = this.affRecord?.AFF_RECORDS?.[10]?.[0];
            let waiverId = this.affRecord?.AFF_RECORDS?.[10]?.[0]; // TODO fix this connection
            let trainingId = this.affRecord?.AFF_RECORDS?.[10]?.[0]; // TODO fix this connection
            let shiftId = this.affRecord?.AFF_RECORDS?.[11]?.[0];
            let assignmentId = this.record?.assignmentId;
            // TODO update activity step message configurations so we can get rid of this block of code
            if (shiftId && !this.shiftSubscription) {
                let payload = {
                    source: 'sds_getProfileField',
                    params: {
                        recordPsp: 'sch',
                        recordId: shiftId,
                        fields: SHIFT_FIELDS,
                    },
                    updateFrequency: 60,
                };
                this.shiftSubscription = this.recordStore.subscribe(payload, this.cId, false, false);
            }
            return {
                vol: this.recordStore.records.vol[volId],
                aff: this.affRecord,
                prevStep: workflowStepStore[this.referenceId + '_' + prevAffId], // TODO make this work with multiples
                nextStep: workflowStepStore[this.referenceId + '_' + nextAffId],
                // TODO make these work with multiples
                lbe: this.recordStore.records.lbe[lbeId],
                waiver: this.recordStore.records.lbe[waiverId],
                training: this.recordStore.records.lbe[trainingId],
                shift: this.recordStore.records.sch[shiftId],
                assignment: this.recordStore.records.assignment[assignmentId],
                ASSIGNMENT: this.recordStore.records.assignment[assignmentId],
                ASSIGNMENT_ID: assignmentId,
                VOLUNTEER_ID: volId
            };
        },
        mappedStep() {
            let activityItem = library.cloneObj(this.activityRecord);
            if (library.objIsEmpty(activityItem)) return {};
            activityItem.record = library.cloneObj(this.affRecord);
            let setCurrItem = (item) => {
                let record = item.record;
                let prevAffId = workflowStepStore.prevAffId || this.prevStep?.AFFILIATION_ID || this.affRecord?.PREV_STEPS?.[0];
                let nextAffId = this.nextStep?.AFFILIATION_ID || this.affRecord?.NEXT_STEPS?.[0];
                if (!this.prevAffId && this.affId !== prevAffId && prevAffId) this.prevAffId = prevAffId; // default to already set prevAffId if it's already set
                let prevItem = workflowStepStore[this.referenceId + '_' + this.prevAffId];
                let nextItem = workflowStepStore[this.referenceId + '_' + nextAffId];
                // Setup sub record merging
                record.stepLbe = this.relatedRecords.lbe;
                record.stepWaiver = this.relatedRecords.waiver;
                record.stepTraining = this.relatedRecords.training;
                record.stepShift = library.cloneObj(this.relatedRecords.shift);
                let tmpShift = library.cloneObj(this.relatedRecords.shift);
                if (tmpShift) {
                    delete tmpShift.ID;
                    delete tmpShift.uiRecordId;
                    delete tmpShift.uiRecordPsp;
                    delete tmpShift.rsLastModified;
                    library.mergeObj(record, tmpShift);
                } // TODO figure out how to get rid of this
                let logicResult = true;
                item.previousStepsComplete = (prevItem?.complete && prevItem?.previousStepsComplete) || !prevItem;
                if (item.includeWhen && item.includeWhen.length) {
                    // need for backend and frontend logic comparison
                    if (!this.editorVisible) {
                        logicResult = library.logicParser.call(this, item.includeWhen, item, item.record, prevItem, nextItem);
                    }
                    if (typeof logicResult === 'boolean') item.includeFrontRes = logicResult;
                }
                // Check visibility also
                if (item.visibleWhen && item.visibleWhen.length) {
                    if (!this.editorVisible) {
                        logicResult = library.logicParser.call(this, item.visibleWhen, item, item.record);
                    }
                    if (typeof logicResult === 'boolean') {
                        item.visible = logicResult;
                        item.visibleFrontRes = logicResult;
                    }
                }

                if (item.enableWhen && item.enableWhen.length) {
                    if (!this.editorVisible) {
                        logicResult = library.logicParser.call(this, item.enableWhen, item, item.record, prevItem, nextItem);
                    }
                    if (typeof logicResult === 'boolean') {
                        item.enable = logicResult;
                        item.enableFrontRes = logicResult;
                    }
                }

                if (item.activeWhen && item.activeWhen.length) {
                    if (!this.editorVisible) {
                        logicResult = library.logicParser.call(this, item.activeWhen, item, item.record, prevItem, nextItem);
                    }
                    if (typeof logicResult === 'boolean') item.active = logicResult;
                }

                if (item.completeWhen && item.completeWhen.length) {
                    logicResult = library.logicParser.call(this, item.completeWhen, item, item.record, prevItem, nextItem);
                    if (typeof logicResult === 'boolean') {
                        item.complete = logicResult;
                        item.completeFrontRes = logicResult;
                    }
                }
                item.expiring = item?.record?.AFF_COMPLIANCE_STATUS === 'Expiring';
                // Set enable, active, and complete styles
                if (item.enable || item.expiring) item.cssClasses += ' item-enabled';
                if (item.active) item.cssClasses += ' item-active';
                if (item.complete) item.cssClasses += ' item-complete';
                // if editorVisible is toggled on: enable, activate, and complete all items to display all buttons and messages.
                if (this.editorVisible) {
                    if (!item.enable) item.cssClasses += ' not-enabled';
                    if (!item.active) item.cssClasses += ' not-active';
                    if (!item.complete) item.cssClasses += ' not-complete';
                    item.active = true;
                    item.enable = true;
                    item.complete = true;
                }
                // Parse Actions
                let currActions = library.cloneObj(item.actions);
                if (!Array.isArray(currActions)) currActions = [];
                currActions.forEach((action, index) => {
                    action.actionId = `action-item_${this.cId.replace(" ", /_/g).toLowerCase()}_${index}`;
                    if (!action.cssClasses) action.cssClasses = '';
                    let included = true;
                    let disabled = false;
                    if (!this.editorVisible) {
                        if (item.complete && action.hideWhenComplete) included = false;
                        if (!item.complete && !item.enable && action.hideWhenDisabled) included = false;
                        if (included && action.includeWhen && action.includeWhen.length) {
                            included = library.logicParser.call(this, action.includeWhen, item.actions[index], record, prevItem, nextItem);
                        }
                        if (included && action.disableWhen && action.disableWhen.length) {
                            disabled = library.logicParser.call(this, action.disableWhen, item.actions[index], record, prevItem, nextItem);
                        }
                    }
                    if (this.editorVisible) {
                        if (action.includeWhen) action.cssClasses += ' include-when-button';
                        if (action.hideWhenComplete) action.cssClasses += ' hide-when-button';
                        if (action.hideWhenDisabled) action.cssClasses += ' disable-when-button';
                    }
                    if (typeof included === 'boolean') action.include = included;
                    if (typeof disabled === 'boolean') action.disabled = disabled;
                });
                let activeActions = currActions.filter((action) => action.include === true);
                // Parse Descriptions
                let currDescriptions = library.cloneObj(item.descriptions);
                if (!Array.isArray(currDescriptions)) currDescriptions = [];
                currDescriptions.forEach((description) => {
                    if (description) {
                        let included = true;
                        if (!this.editorVisible) {
                            if (item.complete && description.hideWhenComplete) included = false;
                            if (!item.complete && !item.enable && description.hideWhenDisabled) included = false;
                            if (included && description.includeWhen && description.includeWhen.length) {
                                included = library.logicParser.call(this, description.includeWhen, description, record, prevItem, nextItem);
                            }
                        }
                        if (this.editorVisible) {
                            if (description.includeWhen) description.cssClasses += ' include-when-message';
                            if (description.hideWhenComplete) description.cssClasses += ' hide-when-message';
                            if (description.hideWhenDisabled) description.cssClasses += ' disable-when-message';
                        }
                        if (typeof included === 'boolean') description.include = included;
                    }
                });
                let activeDescriptions = currDescriptions.filter((description) => description.include === true);
                // Parse Titles
                let currTitles = library.cloneObj(item.titles);
                if (!Array.isArray(currTitles)) currTitles = [];
                currTitles.forEach((title) => {
                    let included = true;
                    if (!this.editorVisible) {
                        if (item.complete && title.hideWhenComplete) included = false;
                        if (included && !item.complete && !item.enable && title.hideWhenDisabled) included = false;
                        if (included && title.includeWhen && title.includeWhen.length) {
                            included = library.logicParser.call(this, title.includeWhen, title, record, prevItem, nextItem);
                        }
                    }
                    if (this.editorVisible) {
                        if (title.includeWhen) title.cssClasses += ' include-when-title';
                        if (title.hideWhenComplete) title.cssClasses += ' hide-when-title';
                        if (title.hideWhenDisabled) title.cssClasses += ' disable-when-title';
                    }
                    if (typeof included === 'boolean') title.include = included;
                });
                let activeTitles = currTitles.filter((title) => title.include === true);
                let newItem = library.cloneObj(item);
                newItem = {
                    ...newItem,
                    record,
                    enable: item.enable,
                    complete: item.complete,
                    visible: item.visible,
                    active: false,
                    hovered: false,
                    selected: false,
                    activeTitles,
                    activeDescriptions,
                    activeActions,
                    // itemIndex: item.itemIndex, // TODO connect this
                    actionButtonDisplay: item.itemActionDisplay,
                    actionBorderRadius: item.actionBorderRadius
                };
                // Run actions after everything else has been processed
                // TODO make this configurable
                if (item.onChangeActions && !this.componentPendingSubscriptions.length && !this.record?.WORKFLOW_DISABLE_AUTO_STATUS_UPDATES) {
                    let cActions = item.onChangeActions;
                    cActions.forEach((iAction) => {
                        let actionResult = true;
                        let referenceId = this.referenceId + '_' + this.affId;
                        if (!iAction.runOnce || (iAction.runOnce && !runOnceActions[referenceId])) {
                            if (iAction.logic) {
                                actionResult = library.logicParser.call(this, iAction.logic, item, item.record, prevItem, nextItem);
                            }
                            if (typeof iAction.executeIfLogicResult !== 'undefined' && actionResult !== iAction.executeIfLogicResult) return;
                            runOnceActions[referenceId] = actionResult;
                            if (Array.isArray(iAction.actions)) {
                                actionStore.runChainedActions(iAction.actions, { ...item.record, prevItem, nextItem }, this);
                            }
                        }
                    });
                }
                return newItem;
            };
            let output = setCurrItem(activityItem);
            // Note: This provides prevItem, nextItem in subSource action params
            let volId = output.record?.VOLUNTEER_ID || output.volId;
            workflowStepStore[this.referenceId + '_' + this.affId] = {
                complete: output.complete,
                previousStepsComplete: output.previousStepsComplete,
                VOLUNTEER_ID: volId,
                visible: output.visible,
                AFFILIATION_ID: output.AFFILIATION_ID,
                ACTIVITY_ENTITY_ID: output.ACTIVITY_ENTITY_ID,
                AFF_STATUS: output.record?.AFF_STATUS,
                AFF_REASON: output.record?.AFF_REASON,
                ASSIGNMENT_ID: output.record?.assignmentId,
                ASSIGNMENT: this.recordStore.records.assignment[output.record?.assignmentId]
                // TODO add more properties including IDs
            };
            if (output.visible) {
                workflowStepStore.prevAffId = this.affId;
            }
            // TODO emit state of this step only
            output.tabIndex = this.record.tabIndex;
            if (activityItem.loaded) this.$emit('ready', output);
            compareLogicFn(this.cId, this.record.workflowId, output);
            return output;
        }
    },
    methods: {
        async onCreate() {
            await library.prepLogicParsingToFront();
            this.logicParserReady = true;
            this.statusOptions = await configStore.attrListOptions("aff_status_2");
            this.reasonOptions = await configStore.attrListOptions("aff_reason_2");
        },
        showRecordSources() {
            // let _this = this;
            // let dialogComponent = {
            //     data() {
            //         return {
            //             volId: _this.volId,
            //             oppId: _this.oppId,
            //             orgId: _this.orgId,
            //             affId: _this.affId,
            //             aeId: _this.activityRecord.ID,
            //             assignmentId: _this.assignmentId,
            //             mappedStep: _this.mappedStep,
            //             viewSourceRecordData: false
            //         };
            //     },
            //     template: `<div>
            //         <span class="sources-label">Record Sources</span>
            //         <span>Volunteer: {{volId}}</span>
            //         <span>Opportunity: {{oppId}}</span>
            //         <span>Organization: {{orgId}}</span>
            //         <span>Affiliation: {{affId}}</span>
            //         <span>Activity: {{aeId}}</span>
            //         <span>Assignment: {{aeId}}</span>
            //         </div>`
            // };
            // library.showDialog(dialogComponent);
        },
        async actionClick(event, control, actionParams) {
            const [action, item] = actionParams;
            let response;
            // Perform an action
            let actionConfig = library.cloneObj(action.action);
            let prevAffId = workflowStepStore.prevAffId || this.prevStep?.AFFILIATION_ID || this.affRecord?.PREV_STEPS?.[0];
            let nextAffId = this.nextStep?.AFFILIATION_ID || this.affRecord?.NEXT_STEPS?.[0];
            if (!this.prevAffId && this.affId !== prevAffId) this.prevAffId = prevAffId; // default to already set prevAffId if it's already set
            let prevItem = workflowStepStore[this.referenceId + '_' + this.prevAffId];
            let nextItem = workflowStepStore[this.referenceId + '_' + nextAffId];
            if (Array.isArray(actionConfig)) {
                let controlParams = {
                    name: control.name,
                    label: control.label
                };
                if (actionParams && actionParams?.[0]?.ACTIVITY_ENTITY_ACTION_ID) {
                    controlParams.ACTIVITY_ENTITY_ACTION_ID = actionParams[0].ACTIVITY_ENTITY_ACTION_ID;
                }
                let tmpRecord = {
                    ...item.record, prevItem, nextItem, controlParams
                };
                response = await actionStore.runChainedActions(actionConfig, tmpRecord, this);
            }
            else {
                if (actionConfig.action) {
                    let payload = library.recordSourceMapper(actionConfig.action, actionConfig.params, { ...item.record, prevItem, nextItem }, this, true);
                    if (payload) response = await actionStore[actionConfig.action](payload);
                }
            }
            return response;
        },
    },
    components: {
        'ejs-skeleton': SkeletonComponent
    }
};
// componentStore.initComponent puts the component into the component store, makes the component available to other vue components, and adds it to the list of component options used in editors
componentStore.initComponent(activityStepPanelCmp, activityStepPanelConfig);

export { activityStepPanelConfig, activityStepPanelCmp };
export default activityStepPanelCmp;
</script>

<style scoped>

.activity-step-panel {
    background: transparent;
    padding: 15px;
    font-family: 'Open Sans';
    display: flex;
}
.record-sources {
    position: absolute;
    right: 4px;
    top: 3px;
}
.record-sources > button {
    font-size: 18px;
    height: 30px;
    width: 32px;
    text-align: center;
    color: rgb(12 27 132 / 80%);
    background: rgba(255, 255, 255, 0.25);
    border: 0 none;
    border-radius: 50%;
}

/* styles from itemList */
.item-icon {
    border-radius: 50%;
    font-weight: bold;
    line-height: 33px;
    text-align: center;
    grid-area: icon;
}
.item-icon {
    width: 32px;
    height: 32px;
    padding-top: 0;
    font-size: 18px;
    background: #e3f1fc;
}
.item-title {
    z-index: 3;
}
.item-content {
    flex-grow: 9;
    grid-area: content;
    padding: 0 10px 0 10px;
}
.item-content p {
    margin: 6px 0;
}
.action-ctrls {
    grid-area: action;
}
.complete-indicator {
    grid-area: complete
}
.item-action-area {
    align-items: center;
}
.item-action-item {
    text-align: right;
    margin: 5px 0 5px 10px;
}
.item-action-item button {
    display: flex;
}
.item-complete {
    background: #c8e5f8;
}
.item-disabled {
    position: relative;
    background: #ddd;
}
.item-disabled.list-item:nth-child(even) {
    background: #ddd;
}
.item-disabled::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background: white;
    cursor: not-allowed;
    opacity: 0.25;
}
.action-btn-inline {
    display: flex;
    align-items: flex-end;
}
:deep(.e-icons.e-complete:before) {
    content: '\e192' !important;
}
/* styles from workflowViewer */
:deep(.expiration-status) {
    margin-top: 15px;
}
:deep(.renewal-in-progress-msg) {
    color: #494949
}
:deep(.expiration-flag) {
    margin-right: 10px;
}
:deep(.current) { color: #16a34a }
:deep(.expiring) { color: #FB8432 }
:deep(.expired) { color: #dc2626 }
:deep(.activity-expiration) {
    display: flex;
    gap: 1rem;
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 0.5rem;
    background: #fef4eb;
    width: fit-content
}
@media (max-width: 620px) {
    :deep(.activity-expiration) {
        flex-direction: column;
    }
    :deep(.btn-renewal.coordinator-action-button) {
        margin: 0 5px;
    }
}
:deep(.activity-expiration) {
    display: flex;
    gap: 1rem;
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 0.5rem;
    background: #fef4eb;
    width: fit-content
}
:deep(.activity-expiration > .expiration-text) {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: #060606;
}
:deep(.activity-expiration > i) {
    color: #ff3e33;
    animation: vibrate 30s infinite ease-in-out;
}
:deep(.activity-expiration > button) {
    align-self: start;
    padding: 0.75rem 1.25rem;
    background: rgb(22, 92, 148);
    border-radius: 0.5rem;
    color: #fff;
    text-decoration: none
}
:deep(.activity-expiration > button:hover) {
    background: #2364f1;
}
:deep(.aff-info-text) {
    display: inline-block;
    padding-right: 8px;
}
:deep(.coordinator-actions), :deep(.info-messages) {
    display: inline-block;
    margin-top: 15px;
}
:deep(.coordinator-messages) {
    border-right: 1px solid #bbbbbb;
}
:deep(.volunteer-messages) {
    opacity: 0.4;
}
:deep(.coordinator-action-button) {
    border: 0 none;
    transition: background .1s ease-in;
    background: rgba(255, 255, 255, .20);
    border-radius: 15px;
    color: #2b2b86;
    padding: 5px 15px;
    margin: 5px;
    display: inline-block;
    text-decoration: underline;
}
:deep(.coordinator-action-button:hover) {
    background: rgba(0, 0, 0, .08);
    transition: all .1s ease-in-out;
}
:deep(.history-button .e-icons) {
    margin-right: 3px;
    position: relative;
    top: 2px;
}
.workflow-loader p {
    display: inline-block;
    line-height: 24px;
    margin: 0 0 0 15px;
    vertical-align: top;
}
.assignment-id {
    font-size: 14px;
}
:deep(.step-not-visible) {
    display: none;
}
@keyframes vibrate {
    0%, 96.9% { transform: rotate(0deg) translateX(0); }
    97.0% { transform: rotate(-3deg) translateX(-2px); }
    97.1% { transform: rotate(3deg)  translateX(2px); }
    97.2% { transform: rotate(-3deg) translateX(-2px); }
    97.3% { transform: rotate(3deg)  translateX(2px); }
    97.4% { transform: rotate(-2.5deg) translateX(-1.8px); }
    97.5% { transform: rotate(2.5deg)  translateX(1.8px); }
    97.6% { transform: rotate(-2.5deg) translateX(-1.8px); }
    97.7% { transform: rotate(2.5deg)  translateX(1.8px); }
    97.8% { transform: rotate(-2deg) translateX(-1.5px); }
    97.9% { transform: rotate(2deg)  translateX(1.5px); }
    98.0% { transform: rotate(-2deg) translateX(-1.5px); }
    98.1% { transform: rotate(2deg)  translateX(1.5px); }
    98.2% { transform: rotate(-1.5deg) translateX(-1px); }
    98.3% { transform: rotate(1.5deg)  translateX(1px); }
    98.4% { transform: rotate(-1.5deg) translateX(-1px); }
    98.5% { transform: rotate(1.5deg)  translateX(1px); }
    98.6% { transform: rotate(-1deg) translateX(-0.8px); }
    98.7% { transform: rotate(1deg)  translateX(0.8px); }
    98.8% { transform: rotate(-0.5deg) translateX(-0.5px); }
    98.9% { transform: rotate(0.5deg)  translateX(0.5px); }
    99%, 100% { transform: rotate(0deg) translateX(0); }
}
</style>
